<template>
  <div class="astro-clock">
    <div class="panelheader">
      <div class="title">Astro Clock</div>
    </div>
    <div class="panel site_lights">
      <img src="../assets/images/weather.svg">
      <div class="sunset">{{clock.sunset_time}}</div>
      <div class="sunset_desc">{{clock.sunset_description1}}</div>
      <div class="sunset_desc">{{clock.sunset_description2}}</div>
      <div class="lights_desc">
        <div>Lights won't turn on before: <strong>{{lights.on}}</strong></div>
        <div>Lights AUTO Off: <strong>{{offTime}}</strong></div>
      </div>
      <div class="light_btns">
        <span class="label">OVERRIDE</span>
        <div class="clear"></div>
        <el-button v-on:click="confirmAllLights('on')" type="save">Lights On</el-button>
        <el-button v-on:click="confirmAllLights('off')" type="cancel">Lights Off</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { converTo24Hr, formatTime, getHourTime } from '../javascript/helpers'
  import auth from '../auth'
  export default {
    name:'astro-clock',
    props:['offTime', 'onTime', 'sunsetOffset'],
    data(){
      return {
        lights:{
          on:'',
          off:''
        },
        clock:{
          sunset_time:'',
          sunset_description1:new Date().toLocaleString('en-AU'),
          sunset_description2:'Sunset in Brisbane QLD'
        },
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      var context = this;

      this.$http.get('https://api.sunrise-sunset.org/json?lat=' + profile.lat + '&lng='+ profile.long + '&date=today&formatted=0').then(result=>{
        var sunset = new Date(result.body.results.sunset);
        this.clock.sunset_time = formatTime(sunset.getHours(), sunset.getMinutes()) + getHourTime(sunset.getHours());
        var onTime = new Date(sunset.getTime() - (context.sunsetOffset * 60 * 1000)); //{sunsetOffset} minutes before sunset
        this.lights.on = formatTime(onTime.getHours(), onTime.getMinutes()) + getHourTime(onTime.getHours());
      });
    },
    mounted(){
      
    },
    methods:{
      updateAllLights(status){
        this.$emit('updateAllLights', status);
      },
      confirmAllLights(status){
        this.$confirm('This will turn ALL lights ' + status.toUpperCase() + ' for this site. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          status = status === 'on' ? 1 : 0;
          this.updateAllLights(status);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled'
          }); 
        });
      },
    }
  }
</script>


// WEBPACK FOOTER //
// SiteAstroClock.vue?7510bce2